// extracted by mini-css-extract-plugin
export default {"card__upper_subtitle":"Cards_card__upper_subtitle__oFCUf","card__title":"Cards_card__title__W2SBQ","card__header_div":"Cards_card__header_div__BaL4M"};